<template>
  <header class="app-header navbar">
    <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
    <!--b-link class="navbar-brand" to="#"></b-link-->
    <button class="navbar-toggler sidebar-toggler d-md-down-none" type="button" @click="sidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
    <b-navbar-nav class="ml-auto">
      <b-nav-item class="d-md-down-none">
        <HeaderDropdownLang/>
      </b-nav-item>
      <HeaderDropdownAccnt/>
    </b-navbar-nav>
  </header>
</template>
<script>
  import HeaderDropdownAccnt from './HeaderDropdownAccnt.vue'
  import HeaderDropdownLang from './HeaderDropdownLang.vue'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'header',
    components: {
      HeaderDropdownAccnt,
      HeaderDropdownLang
    },
    methods: {
      sidebarToggle (e) {
        e.preventDefault()
        document.body.classList.toggle('sidebar-hidden')
      },
      sidebarMinimize (e) {
        e.preventDefault()
        document.body.classList.toggle('sidebar-minimized')
      },
      mobileSidebarToggle (e) {
        e.preventDefault()
        document.body.classList.toggle('sidebar-mobile-show')
      }
    },
    computed:
    {
      ...mapGetters([
        'globals'
      ])
    }
  }
</script>
